import React from 'react';

const SelectField = ({ 
  label, 
  value, 
  onChange, 
  options = [], 
  name, 
  required = false, 
  disabled = false, 
  className = '',
  icon = null
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-wider text-slate-600 dark:text-slate-400 mb-1.5">
          {label}
          {required && <span className="text-rose-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative rounded-lg shadow-sm">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
            {icon}
          </div>
        )}
        <select
          value={value ?? ''}
          onChange={onChange}
          name={name}
          disabled={disabled}
          required={required}
          className={`
            w-full px-3.5 py-2.5 rounded-lg text-sm appearance-none
            bg-slate-50/70 dark:bg-slate-900/60
            text-slate-900 dark:text-slate-100
            border border-slate-200 dark:border-slate-700
            focus:bg-white dark:focus:bg-slate-900
            focus:border-emerald-500 dark:focus:border-emerald-500
            focus:ring-2 focus:ring-emerald-500/20
            transition-all duration-200 ease-in-out outline-none
            cursor-pointer
            ${icon ? 'pl-10' : ''}
            ${disabled ? 'opacity-50 cursor-not-allowed bg-slate-100 dark:bg-slate-800' : ''}
          `}
        >
          {options.map((option) => (
            <option 
              key={option.value} 
              value={option.value}
              className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 py-1"
            >
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-slate-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SelectField;
